import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button, Switch, FormControlLabel } from '@mui/material';
import { colors } from '../colors';

const EditSurveyModal = ({ open, onClose, onSave, survey }) => {
    const [surveyName, setSurveyName] = useState(survey.surveyName || '');
    const [surveyDescription, setSurveyDescription] = useState(survey.surveyDescription || '');
    const [validTill, setValidTill] = useState(survey.validTill ? new Date(survey.validTill).toISOString().substring(0, 10) : '');
    const [consentNeeded, setConsentNeeded] = useState(survey.consentNeeded || false);

    const handleSave = () => {
        const updatedSurvey = {
            ...survey,
            surveyName,
            surveyDescription,
            validTill,
            consentNeeded,  // Include the consentNeeded field
        };
        onSave(updatedSurvey);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="edit-survey-modal"
            aria-describedby="edit-survey-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: 300, sm: 400, md: 500 }, // Responsive width
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '12px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography
                    variant="h6"
                    id="edit-survey-modal"
                    sx={{
                        fontWeight: 'bold',
                        color: colors.primaryApplicationText,
                        mb: 1,
                    }}
                >
                    Edit Survey
                </Typography>

                {/* Survey Name */}
                <TextField
                    fullWidth
                    margin="normal"
                    label="Survey Name"
                    value={surveyName}
                    onChange={(e) => setSurveyName(e.target.value)}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: colors.primaryBannerBlue, // Custom border color
                            },
                            '&:hover fieldset': {
                                borderColor: colors.primaryApplicationText,
                            },
                        },
                    }}
                />

                {/* Survey Description */}
                <TextField
                    fullWidth
                    margin="normal"
                    label="Survey Description"
                    multiline
                    rows={3}
                    value={surveyDescription}
                    onChange={(e) => setSurveyDescription(e.target.value)}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: colors.primaryBannerBlue,
                            },
                            '&:hover fieldset': {
                                borderColor: colors.primaryApplicationText,
                            },
                        },
                    }}
                />

                {/* Valid Till */}
                <TextField
                    fullWidth
                    margin="normal"
                    label="Valid Till"
                    type="date"
                    value={validTill}
                    onChange={(e) => setValidTill(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: colors.primaryBannerBlue,
                            },
                            '&:hover fieldset': {
                                borderColor: colors.primaryApplicationText,
                            },
                        },
                    }}
                />

                {/* Toggle for User Consent */}
                <FormControlLabel
                    control={
                        <Switch
                            checked={consentNeeded}
                            onChange={(e) => setConsentNeeded(e.target.checked)}
                            color="primary"
                        />
                    }
                    label={
                        <Typography sx={{ fontSize: '0.9rem', color: colors.primaryApplicationText }}>
                            Require User Consent
                        </Typography>
                    }
                    sx={{ mt: 1 }}
                />

                {/* Buttons */}
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={{
                            color: colors.primaryBannerBlue,
                            borderColor: colors.primaryBannerBlue,
                            '&:hover': {
                                backgroundColor: '#F0F4F8',
                                borderColor: colors.primaryApplicationText,
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSave}
                        variant="contained"
                        sx={{
                            backgroundColor: colors.primaryBannerBlue,
                            color: '#ffffff',
                            '&:hover': {
                                backgroundColor: colors.primaryApplicationText,
                            },
                        }}
                    >
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default EditSurveyModal;
